export enum NotificationSourceEnum {
    None = 0,
    AssignmentTransferred = 1,
    AssignmentTakenOver = 2,
    NewDocumentAvailable = 3,
    NewPlanningAvailable = 4,
    NewNewsAvailable = 5,
    OpenAssignmentNotTookOver = 6,
    NewOpenAssignmentsAvailable = 7,
    Example = 99
}